import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetListOrgStructureFailed,
  actGetListOrgStructureSuccess,
  MASTER_GET_LIST_ORG_STRUCTURE,
} from '../../actions/org-structure'
import { apiGetOrgStructureTree } from '../../apis/org-structure'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetList(action) {
  try {
    const response = yield call(apiGetOrgStructureTree, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data,
      }
      yield put(actGetListOrgStructureSuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetListOrgStructureFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(MASTER_GET_LIST_ORG_STRUCTURE, doGetList)
}
